module.exports = __webpack_public_path__ + "img/site_image_old.265d12ff.jpg";